<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="monitorules" label="自动规则列表"></TabPane>
            <TabPane v-if="currentRoute !== 'monitorules'" name="monitoradd" :label="`${addName}自动规则`"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <router-view />
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'monitorlayout',
  computed: {
    addName() {
      return this.editStat ? '修改' : '新增'
    },
    currentRoute() {
      return this.$route.name === 'monitorules' ? 'monitorules' : 'monitoradd'
    },
    editStat() {
      return this.$route.name === 'monitoredit'
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.replace({ name })
    },
    getCurrent() {
      if (this.$route.name === 'monitor') this.changeRouter('monitorules')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
